import { createContext } from 'react';
import GlobalAppContextProps from './global-app-context-props';

const GlobalAppContext = createContext<GlobalAppContextProps>({
	isEditView: false,
	setIsEditView: () => {
		/** */
	},
});
export default GlobalAppContext;
